export default "__VITE_ASSET__IttZ1gvy__"